module.exports = __webpack_public_path__ + "static/media/iphone13.1d6f58b8.png";